function Services(){
const services = [
  { iconClass: "fas fa-bolt", title: "Express Parcel Services", description: "Fast and time-sensitive logistics services." },
  { iconClass: "fas fa-file-contract", title: "Contractual",  description: "Reliable and flexible contractual transport solutions tailored to your business needs." },
  { iconClass: "fas fa-route", title: "Logistics", description: "Comprehensive logistics management ensuring smooth and timely delivery of goods." },
  { iconClass: "fas fa-moon", title: "Over night delivery", description: "Secure and fast overnight delivery service to meet urgent shipment requirements." },
  /*{ iconClass: "fas fa-clock", title: "Next working day delivery", description: "Guaranteed delivery on the next working day to keep your operations on schedule." },*/
  { iconClass: "fas fa-truck-moving", title: "Full Truck Load (FTL)", description: "Reliable full-capacity transport for large consignments." },
  { iconClass: "fas fa-boxes", title: "Part Load", description: "Flexible, cost-efficient shipping for smaller cargo." },
  { iconClass: "fas fa-door-open", title: "Door-to-Door Delivery", description: "Complete pickup and delivery at your doorstep." },
  { iconClass: "fas fa-warehouse", title: "Warehousing", description: "Safe and secure storage for your goods." },
];

return (
  <section id="services" className="services-section">
    <h2 className="services-title">Our Services</h2>
    <div className="services-grid">
      {services.map((service, index) => (
        <div className="service-card" key={index}>
          <div className="service-icon">
            <i className={service.iconClass}></i>
          </div>
          <h3 className="service-title">{service.title}</h3>
          <p className="service-description">{service.description}</p>
        </div>
      ))}
    </div>
  </section>
);
}

export default Services